import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { map, of, catchError, mergeMap, tap } from 'rxjs'
import { CommonService } from 'src/app/services/common/common.service'
import { LoginService } from 'src/app/services/login/login.service'
import { logout_failed, logout_success, start_logout } from '../action/logout.action'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { environment } from 'src/environments/environment'
import { LocalStorageService } from 'src/app/services/common/local-storage.service'

@Injectable()
export class LogoutEffects {
  constructor(private actions$: Actions, private loginService: LoginService, private cs: CommonService) {}

  logout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(start_logout),
      mergeMap((action) =>
        this.loginService.logout().pipe(
          map((response: any) => {
            return logout_success({ data: response })
          }),
          catchError((error: any) => {
            const errorMsg = this.cs.extractApiErrorMessage(error?.message)
            this.cs.showError(errorMsg || 'Logout failed', 'LOGOUT FAILED', true)
            return of(logout_failed(error))
          })
        )
      )
    )
  )

  logoutRedirect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(logout_success),
        tap((action) => {
          LocalStorageService.remove('refresh')
          LocalStorageService.remove(environment.token_prefix + 'auth-token')
          this.cs.routeWithPathParams(GlobalConstants.ROUTING.LOGIN, [LocalStorageService.get('companyDomain')])
        })
      )
    },
    { dispatch: false }
  )
}
